@if (!noLinks) {
  <side-panel-header [displayText]="downloadsLabel"></side-panel-header>
  @for (attribute of attributeList; track attribute) {
    @if (attribute.prop && documentIds[attribute.prop]) {
      <div
        role="button"
        aria-label="Download PDF button"
        class="SidePanel__action"
        tabindex="0"
        (click)="downloadPDF(attribute.prop)"
      >
        <icon
          [name]="attribute.icon ? attribute.icon : 'pdf'"
          [config]="{
            format: 'svg',
            type: 'link',
            size: 'medium',
          }"
        >
        </icon>
        <p
          dataClickEvent
          [attr.aria-label]="attribute.label"
          class="SidePanel__label t-bold t-link"
        >
          {{ attribute.label }}
        </p>
      </div>
    }
  }
}
